import { createReducer } from "@reduxjs/toolkit"

import { setCurrentUser, setPvOption } from "./actions"

interface AuthState {
  currentUser: any
  pvOption: boolean
}

const initialState: AuthState = {
  currentUser: null,
  pvOption: false,
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setCurrentUser, (state, action) => {
    state.currentUser = action.payload
  })
  builder.addCase(setPvOption, (state, action) => {
    state.pvOption = action.payload
  })
})

export default reducer
